import { CATEGORY_LIST, CATEGORIES } from "@/lib/leadMeta";
import { Check, Star } from "lucide-react";

export const InsuranceTypePicker = ({ value = [], onChange, primary, onPrimaryChange }) => {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((v) => v !== k) : [...value, k]);
  const showStars = typeof onPrimaryChange === "function";
  return (
    <div className="mt-1.5 flex flex-wrap gap-2" data-testid="insurance-type-picker">
      {CATEGORY_LIST.map((k) => {
        const active = value.includes(k);
        const c = CATEGORIES[k];
        const isPrimary = primary === k;
        return (
          <span key={k} className="inline-flex items-center">
            <button
              type="button"
              onClick={() => toggle(k)}
              data-testid={`type-chip-${k}`}
              className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors"
              style={{ backgroundColor: c.color + (active ? "33" : "1a"), color: c.color, borderColor: c.color + (active ? "" : "55") }}
            >
              <c.icon className="h-3.5 w-3.5" /> {c.label}
              {active && !showStars && <Check className="h-3 w-3" />}
              {active && showStars && isPrimary && <Star className="h-3 w-3 fill-current text-amber-400" />}
            </button>
            {active && showStars && !isPrimary && (
              <button type="button" title="Mark as primary coverage" onClick={() => onPrimaryChange(k)}
                data-testid={`type-primary-${k}`} className="-ml-0.5 rounded-full p-1 text-muted-foreground hover:text-amber-400">
                <Star className="h-3.5 w-3.5" />
              </button>
            )}
          </span>
        );
      })}
    </div>
  );
};
